var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Watch, PropertyConverters, PacemEventTarget, Utils, PCSS } from './_default-imports';
import { Debounce } from '../../decorators';
//namespace Pacem.Components {
// TODO: go native with IntersectionObserver 
// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
// TODO: elementify the concept of an ochestrator
// see also scroll-aware
/** @deprecated */
class PacemViewportOrchestrator {
    constructor(_global) {
        this._global = _global;
        this.viewports = [];
        this._checkHandler = (evt) => {
            this._oncheck(evt);
        };
    }
    register(vport) {
        const vports = this.viewports, win = this._global;
        if (vports.indexOf(vport) === -1) {
            vports.push(vport);
            if (vports.length === 1) {
                // TODO: check against overflow: 'auto' | 'scroll' elements with constrained heights/widths...
                win.addEventListener('resize', this._checkHandler, false);
                win.addEventListener('scroll', this._checkHandler, false);
                win.addEventListener('transitionend', this._checkHandler, false);
                win.addEventListener('animationend', this._checkHandler, false);
            }
            this._oncheck();
        }
    }
    unregister(vport) {
        var ndx;
        const vports = this.viewports, win = this._global;
        if ((ndx = vports.indexOf(vport)) !== -1) {
            vports.splice(ndx, 1);
            if (vports.length === 0) {
                win.removeEventListener('resize', this._checkHandler, false);
                win.removeEventListener('scroll', this._checkHandler, false);
                win.removeEventListener('transitionend', this._checkHandler, false);
                win.removeEventListener('animationend', this._checkHandler, false);
            }
            this._oncheck();
        }
    }
    isElementVisible(el, ignoreHorizontal) {
        const vportSize = Utils.windowSize;
        var doc = this._global.document, rect = el.getBoundingClientRect(), vWidth = vportSize.width, vHeight = vportSize.height, efp = function (x, y) { return document.elementFromPoint(x, y); };
        return rect.bottom > 0 && rect.top < (0 + vHeight)
            && (ignoreHorizontal || (rect.left < (vWidth + 0) && rect.right > 0));
    }
    _oncheck(evt) {
        for (var el of this.viewports) {
            const tget = el.target || el;
            const newviz = this.isElementVisible(tget, el.ignoreHorizontal);
            if (newviz !== el.visible) {
                var visible = el.visible = newviz;
                if (visible)
                    Utils.addClass(tget, PCSS + '-in-viewport');
                else
                    Utils.removeClass(tget, PCSS + '-in-viewport');
            }
        }
    }
}
__decorate([
    Debounce(100)
], PacemViewportOrchestrator.prototype, "_oncheck", null);
const ORCHESTRATOR = new PacemViewportOrchestrator(window);
/** @deprecated */
let PacemViewportAwareElement = class PacemViewportAwareElement extends PacemEventTarget {
    viewActivatedCallback() {
        super.viewActivatedCallback();
        //
        ORCHESTRATOR.register(this);
    }
    disconnectedCallback() {
        ORCHESTRATOR.unregister(this);
        //
        super.disconnectedCallback();
    }
};
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemViewportAwareElement.prototype, "visible", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemViewportAwareElement.prototype, "target", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemViewportAwareElement.prototype, "ignoreHorizontal", void 0);
PacemViewportAwareElement = __decorate([
    CustomElement({ tagName: P + '-viewport-aware' })
], PacemViewportAwareElement);
export { PacemViewportAwareElement };
//}
